import script from "./Person.vue?vue&type=script&setup=true&lang=js"
export * from "./Person.vue?vue&type=script&setup=true&lang=js"

import "./Person.vue?vue&type=style&index=0&id=00cf2736&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00cf2736"]])

export default __exports__